<template>
    <div>
        <a :href="tb.href" :style="'color:'+(tb.color?tb.color:'')" target="_blank">{{tb.text}}</a>
     
    </div>
</template>

<script>
export default {
    name: 'DownloadLink',
    props:['tb'],
    components: {  },
    directives: {  },
    data() {
        return {
            
        };
    },
    mounted() {
        
    },
    methods: {
        
    },
};
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/fields/DownloadLink.vue